var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App",attrs:{"id":"app"}},[_c('main-header'),_c('main',{staticClass:"MainContent",attrs:{"id":"main"}},[_c('router-view')],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }